/** Drop-in shim so modules can `import { toast } from 'sonner'` without adding sonner. */
import hotToast from 'react-hot-toast';

const toast = Object.assign(
  (message, opts) => hotToast(message, opts),
  {
    success: hotToast.success.bind(hotToast),
    error: hotToast.error.bind(hotToast),
    loading: hotToast.loading.bind(hotToast),
    custom: hotToast.custom.bind(hotToast),
    dismiss: hotToast.dismiss.bind(hotToast),
    remove: hotToast.remove?.bind(hotToast),
    promise: hotToast.promise?.bind(hotToast),
    // Sonner-compatible helpers (react-hot-toast has no .message / .info)
    message: (message, opts) => {
      const text = typeof opts?.description === 'string'
        ? `${message} — ${opts.description}`
        : message;
      return hotToast(text, opts);
    },
    info: (message, opts) => hotToast(message, opts),
    warning: (message, opts) => hotToast(message, { ...opts, icon: '⚠️' }),
  }
);

export { toast };
export default toast;
